export interface SignupResult {
  session_jwt: string;
  session_token: string;
}

export const isSignupResult = (obj: unknown): obj is SignupResult => {
  return (
    typeof obj === "object" &&
    obj !== null &&
    typeof (obj as Record<string, unknown>).session_jwt === "string" &&
    typeof (obj as Record<string, unknown>).session_token === "string"
  );
};
